import axios from 'util/axiosConfig';

export const getDictationComments = async (reportId) => {
    return await axios.get(`/api/v1/dictation-comments`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const createDictationCommentAPI = async (createDictationComment) => {
    return await axios.post(`/api/v1/add-dictation-comment`, createDictationComment)
        .then(function (response) {
            if (response.data) {
                return {
                    success: true, comment: response.data
                };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}